import { Fragment } from "react"
import PropTypes from "prop-types"
import { colors } from "components/shared/admin_colors"
import MissingAttendeeInfoError from "./MissingAttendeeInfoError"

const AttendeeQuestions = ({ questions }) => {
  return (
    <>
      {questions.map(question => {
        if (question.publiclyRequired && !question.answerForAttendee) {
          return (
            <Fragment key={question.id}>
              <dt className="reg-details__label reg-details__item-incomplete mt-1@print">
                {question.question}
              </dt>
              {!question.header && <MissingAttendeeInfoError className="mt-4p" />}
            </Fragment>
          )
        } else {
          return (
            <Fragment key={question.id}>
              <dt
                className={`reg-details__label mt-1@print ${question.header && "pb-1 mb-2"}`}
                css={{
                  borderBottom: question.header ? `1px solid ${colors.neutral_060}` : "none",
                  fontWeight: question.header ? "700" : ""
                }}
              >
                {question.question}
                {question.description && (
                  <div className="font-size-5 c-neutral_020 fw-400">{question.description}</div>
                )}
              </dt>
              {!question.header && (
                <dd className="mb-2">
                  {question.answerForAttendee ? (
                    question.answerForAttendee
                  ) : (
                    <MissingAttendeeInfoError showErrorExplanation={false} />
                  )}
                </dd>
              )}
            </Fragment>
          )
        }
      })}
    </>
  )
}

AttendeeQuestions.propTypes = {
  questions: PropTypes.array
}

export default AttendeeQuestions
